import { handleResponse, handleError } from "./apiUtils";
import { API, graphqlOperation } from 'aws-amplify';
import moment from 'moment';
import * as queries from '../graphql/queries';
import * as mutations from '../graphql/mutations';
import getOffsetTime from '../utils/getOffsetTime';
import _ from 'underscore';

export async function getCostObjects(parameters) {
  let response = await API.graphql(graphqlOperation(queries.assignmentApIgetCostObjects, parameters));
  return response.data.assignmentAPIgetCostObjects;
}

export async function getRelevantJobs(startTime, userId) {
  let response = await API.graphql(graphqlOperation(queries.assignmentApIgetRelevantJobs,
      {
        startTime,
        userId
      }));
  return response.data.assignmentAPIgetRelevantJobs;
}

export async function getRelevantJobsForCostObject(startTime, userId, costObjectId, costObjectTypeId) {
  let response = await API.graphql(graphqlOperation(queries.assignmentApIgetRelevantJobsForCostObject,
      {
        startTime,
        userId,
        costObjectId,
        costObjectTypeId
      }));
  return response.data.assignmentAPIgetRelevantJobsForCostObject;
}

export async function getRelatedBranches(userId) {

  let response = await API.graphql(graphqlOperation(queries.assignmentApIgetRelatedBranches,
      {
        userId
      }));
  return response.data.assignmentAPIgetRelatedBranches;
}

export async function getGroupsByBranchAndResource(branchId, resourceId) {
  let response = await API.graphql(graphqlOperation(queries.assignmentApIgetGroupsByBranchAndResource,
      {
        branchId,
        resourceId
      }));
  return response.data.assignmentAPIgetGroupsByBranchAndResource;
}

export async function getServicesByDate(branchId, resourceId, startTime, endTime, priceMethodId, groupId, timeZoneId) {

  let response = await API.graphql(graphqlOperation(queries.assignmentApIgetServicesByDate,
      {
        branchId,
        resourceId,
        startTime,
        endTime,
        priceMethodId,
        groupId,
        timeZoneId
      }));
  return response.data.assignmentAPIgetServicesByDate;
}

export async function getActivityTypes(relatedServiceId, referenceDate) {

  let response = await API.graphql(graphqlOperation(queries.assignmentApIgetActivityTypes,
      {
        relatedServiceId,
        referenceDate
      }));
  return response.data.assignmentAPIgetActivityTypes;
}

export async function getServiceSalaryLevel(serviceId) {

  let response = await API.graphql(graphqlOperation(queries.assignmentApIgetServiceSalaryLevel, { serviceId }))
    .catch(handleError);

  return response.data.assignmentAPIgetServiceSalaryLevel;
}

export async function getServicePrimaryRate(serviceId) {

  let response = await API.graphql(graphqlOperation(queries.assignmentApIgetServicePrimaryRate, { serviceId }))
    .catch(handleError);

  return response.data.assignmentAPIgetServicePrimaryRate;
}

export async function getJobSalariesByService(serviceId, startTime) {

  let response = await API.graphql(graphqlOperation(queries.assignmentApIgetJobSalariesByService, { serviceId, startTime }))
    .catch(handleError);

  return response.data.assignmentAPIgetJobSalariesByService;
}

export async function logJobStart(userId, operation) {
  let response = await API.graphql(graphqlOperation(mutations.assignmentApIlogJobStart,
    {
      userId,
      operation
    }))
    .catch(handleError);

  return response.data.assignmentAPIlogJobStart;
}

export async function logJobFinish(logControlId, jobId) {

  let response = await API.graphql(graphqlOperation(mutations.assignmentApIlogJobFinish,
    {
      logControlId,
      jobId
    }))
    .catch(handleError);

  return response.data.assignmentAPIlogJobFinish;
}

export async function createJob(parameters) {

  parameters.IPAddress = '27.0.0.1';

  let response = await API.graphql(graphqlOperation(mutations.assignmentApIcreateJob, parameters))
      .catch(handleError);

  return response.data.assignmentAPIcreateJob;
}

export async function createJobElement(parameters) {

  parameters.IPAddress = '27.0.0.1';

  let response = await API.graphql(graphqlOperation(mutations.assignmentApIcreateJobElement, parameters))
      .catch(handleError);

  return response.data.assignmentAPIcreateJobElement;
}

export async function getValidateEmptyJob(assignmentId) {

  let response = await API.graphql(graphqlOperation(queries.assignmentApIgetValidateEmptyJob, { assignmentId }))
    .catch(handleError);

  return response.data.assignmentAPIgetValidateEmptyJob;
}

export async function deleteJob(parameters) {

  let response = await API.graphql(graphqlOperation(mutations.assignmentApIdeleteJob, parameters))
    .catch(handleError);

  return response.data.assignmentAPIdeleteJob;
}

export async function deleteJobElement(parameters) {

  let response = await API.graphql(graphqlOperation(mutations.assignmentApIdeleteJobElement, parameters))
    .catch(handleError);

  return response.data.assignmentAPIdeleteJobElement;
}

export async function getJob(jobId) {

  let response = await API.graphql(graphqlOperation(queries.assignmentApIgetJob, { jobId }))
    .catch(handleError);

  return response.data.assignmentAPIgetJob;
}

export async function getJobElement(jobElementId) {

  let response = await API.graphql(graphqlOperation(queries.assignmentApIgetJobElement, { jobElementId }))
    .catch(handleError);

  return response.data.assignmentAPIgetJobElement;
}

export async function getCostObject(costObjectId, costObjectTypeId) {

  let response = await API.graphql(graphqlOperation(queries.assignmentApIgetCostObject, { costObjectId, costObjectTypeId }))
    .catch(handleError);

  return response.data.assignmentAPIgetCostObject;
}

export async function getJobElementsWithDetails(jobId) {

  let response = await API.graphql(graphqlOperation(queries.assignmentApIgetJobElementsWithDetails, { jobId}))
    .catch(handleError);

  return response.data.assignmentAPIgetJobElementsWithDetails;
}

export async function getService(serviceId) {

  let response = await API.graphql(graphqlOperation(queries.assignmentApIgetService, { serviceId }))
    .catch(handleError);

  return response.data.assignmentAPIgetService;
}

export async function getGroupsByBranchInCompany(branchId) {

  let response = await API.graphql(graphqlOperation(queries.assignmentApIgetGroupsByBranchInCompany, { branchId }))
    .catch(handleError);

  return response.data.assignmentAPIgetGroupsByBranchInCompany;
}

export async function getAssignmentServicesByGroup(groupId, serviceId) {

  let response = await API.graphql(graphqlOperation(queries.assignmentApIgetAssignmentServicesByGroup, { groupId, serviceId }))
    .catch(handleError);

  return response.data.assignmentAPIgetAssignmentServicesByGroup;
}

export async function getServicesByGroup(groupId, serviceId) {

  let response = await API.graphql(graphqlOperation(queries.assignmentApIgetServicesByGroup, { groupId, serviceId }))
    .catch(handleError);

  return response.data.assignmentAPIgetServicesByGroup;
}


export async function updateJobElement(parameters) {

  parameters.IPAddress = '27.0.0.1';
  // console.log('***** UPDATE JOB ELEMENT PARAMETERS ******'); // debug
  // console.log(parameters); // debug

  let response = await API.graphql(graphqlOperation(mutations.assignmentApIupdateJobElement, parameters))
    .catch(handleError);

  return response.data.assignmentAPIupdateJobElement;
}

export async function getJobElements(jobId) {

  let response = await API.graphql(graphqlOperation(queries.assignmentApIgetJobElements, { jobId }))
    .catch(handleError);

  return response.data.assignmentAPIgetJobElements;
}

export async function getApprovedJobElements(jobId) {

  let response = await API.graphql(graphqlOperation(queries.assignmentApIgetApprovedJobElements, { jobId }))
    .catch(handleError);

  return response.data.assignmentAPIgetApprovedJobElements;
}

export async function updateJob(parameters) {
  parameters.IPAddress = '27.0.0.1';
  let response = await API.graphql(graphqlOperation(mutations.assignmentApIupdateJob, parameters))
    .catch(handleError);

  return response.data.assignmentAPIupdateJob;
}




// WEBPACK FOOTER //
// ./src/api/assignmentApi.js